import gcu from './fr/gcu'
import legacynotice from './fr/legacy_notice'

export default {
  onlinepage: {
    message:
      "Cette partie de l'application n'est pas compatible avec les écrans compactes. Veuillez basculer sur un ordinateur pour plus de confort",
  },
  request: {
    user: {
      notfound: 'Utilisateur introuvable',
    },
    lineid: {
      notfound: 'Attribution de fréquence introuvable',
    },
    stakeholder: {
      notfound: 'Titulaire introuvable',
      deactivate: 'Ce titulaire est désactivé',
    },
    roaming_team: {
      notfound: 'Équipe mobile introuvable',
    },
    site: {
      notfound: 'Site de contrôle introuvable',
    },
    venue: {
      notFound: 'Lieu d\'événement introuvable',
      codeNotUnique: 'Le code saisi existe déjà pour un autre lieu.',
    },
    equipmentType: {
      notFound: 'Type d\'équipement introuvable',
      codeNotUnique: 'Le code saisi existe déjà pour un autre type d\'équipement.'
    }
  },
  validations: {
    required: 'Ce champ est requis.',
    minValue: 'La valeur doit être supérieure à {min}.',
    minLength: 'Le champ doit contenir au minimum {min} caractères.',
    maxLength: 'Le champ doit contenir au maximum {max} caractères.',
    email: "L'adresse email saisie est invalide.",
    sameAsEmail: "L'adresse email et sa confirmation ne sont pas identiques.",
    sameAsPassword:
      'Le mot de passe et sa confirmation ne sont pas identiques.',
    passwordPattern:
      'Le mot de passe doit faire entre 8 et 30 caractères et contenir au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial',
    passwordSpecialCharacter: 'Caractères spéciaux acceptés',
    numberArrayPattern: 'La liste ne doit contenir que des nombres entiers.',
    phoneNumberPattern: 'Le numéro de téléphone saisi est invalide.',
    appointmentEndTimeGreaterThan:
      "L'heure de fin du créneau doit être supérieure à l'heure de début",
    isAfterDate: 'La date de fin doit être supérieure à la date de début.',
    captchaanswer: {
      empty: 'La réponse est invalide.',
      invalid: 'La réponse est invalide.',
    },
    error_exeption:
      "Vos informations de connexion sont invalides. Veuillez vérifier que vous avez créé un compte et l'avez activé via l'email d'activation envoyé à l'issue de votre inscription.",

    login: {
      notapproved: 'Votre compte est en cours d\'approbation. Vous ne pouvez pas accéder à l\'application pour le moment.',
      credentials: 'Adresse email ou mot de passe invalide.',
      locked: 'Votre compte est bloqué.',
      email: {
        invalid: "L'adresse email est invalide.",
      },
      password: {
        empty: 'Le Mot de passe ne peut pas être vide.',
      },
      failed: 'Adresse email ou mot de passe incorrect. Vous devriez peut-être réinitialiser votre mot de passe.',
      refused: 'Votre demande de compte a été rejetée. Vous ne pouvez pas accéder à l\'application'
    },
    register: {
      password: {
        empty: 'Le mot de passe ne peut pas être vide.',
      },
      email: {
        empty: "L'adresse email ne peut pas être vide.",
        exists: "L'adresse email saisie existe pour un autre compte.",
      },
      firstname: {
        empty: 'Le prénom ne peut pas être vide.',
        letters: 'Le prénom ne peut contenir que des lettres',
      },
      lastname: {
        empty: 'Le nom ne peut pas être vide.',
        letters: 'Le nom ne peut contenir que des lettres',
      },
      stakeholderId: {
        empty: 'Le titulaire ne peut pas être vide.',
        deactivate: 'Ce titulaire est désactivé',
      },
      company: {
        empty: 'La société utilisatrice ne peut pas être vide.',
      },
    },
    delete: {
      appointment: "L'utilisateur a des rendez-vous associés",
      appointmentpast: 'Un ou plusieurs rendez-vous est déjà passé.',
      stakeholder:
        'Le titulaire a une attribution de fréquence ou un contact lié !',
    },
    user: {
      delete: {
        appointment: "L'utilisateur a des rendez-vous associés",
      },
      validation: {
        email: {
          exists: 'Un utilisateur avec la même adresse email existe.',
        },
      },
      update: {
        admin:
          'Un agent ne peut pas définir un utilisateur comme administrateur.',
      },
      admin: {
        role: 'Un administrateur ne peut pas modifier ses droits.',
      },
      yubekey: {
        exists: 'Un utilisateur avec la même yubekey existe',
      },
      agent: {
        not_approved: 'L\'email est lié à un compte contact non approuvé.'
      }
    },
    change: {
      password: {
        invalidToken: 'Le jeton de changement de mot de passe est invalide',
        invalid: 'Les mots de passe ne sont pas identiques.',
        format:
          'Le mot de passe doit contenir 8 caractères minimum avec 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial. (maximum 30 caractères)',
      },
      captchaanswer: {
        empty: 'La réponse  est invalide',
        invalid: 'La réponse est invalide',
      },
    },
    dummy: {
      name: {
        size: 'Le nom doit contenir entre 5 et 50 caractères.',
      },
      private: {
        size: 'Le champs privé doit contenir entre 1 et 10 caractères.',
      },
    },
    userId: {
      invalid: "L'identifiant de l'utilisateur est invalide",
    },
    activation: {
      alreadyactivated: "L'utilisateur est déjà activé.",
      activationCode: {
        invalid: "Le code d'activation est invalide.",
      },
    },
    request: {
      user: {
        empty: "L'utilisateur ne doit pas être vide",
        invalidrole: "L'utilisateur doit être un contact",
      },
      totaltime: {
        invalid: 'Le temps total ne correspond pas aux équipements sélectionnés',
        specialRequest: 'La demande est spéciale'
      },
      stakeholderlocked: 'Ce titulaire est désactivé',
    },
    appointment: {
      conflict: "Un des créneaux sélectionnés n'est plus disponible",
      wrongsite: 'Le site sélectionné ne correspond pas au site de contrôle unique configuré',
      multipleOf5Min: 'La durée du créneau doit être un multiple de 5 minutes',
      overlap: 'Ce créneau comprend des horaires non disponibles',
      exceedsControlDuration:
        'La durée planifiée excède le temps de contrôle estimé',
      greaterThan0: 'La durée du créneau doit être supérieure à 0',
      appointment: {
        empty: 'Le rendez-vous ne doit pas être vide',
      },
      start: {
        empty: 'La date de départ ne doit pas être vide',
        passed: 'La date de départ ne doit pas être passée',
      },
      end: {
        empty: 'La date de fin ne doit pas être vide',
        invalid: 'La date de fin est invalide',
      },
      duration: {
        toolong: 'Un créneau ne doit pas durer plus de 3 heures',
      },
      site: {
        disabled: 'Le site n\'est pas ouvert',
      }
    },
    stakeholder: {
      id: {
        empty: "L'identifiant du titulaire ne peut pas être vide.",
        exists: "L'identifiant saisie existe pour un autre titulaire.",
      },
      name: {
        empty: 'Le nom du titulaire ne peut pas être vide.',
      },
    },
    office: {
      name: {
        empty: 'Le nom du bureau ne peut pas être vide.',
      },
      site: {
        empty: 'Le bureau doit appartenir à un site.',
      },
      planning: {
        empty: "Le bureau doit avoir des horaires d'ouverture.",
      },
      openDate: {
        empty: "Le bureau doit avoir une date d'ouverture.",
      },
      closeDate: {
        empty: 'Le bureau doit avoir une date de fermeture.',
      },
      dates: {
        invalid: "Les dates d'ouvertures sont invalides.",
      },
    },
    dayplanning: {
      morningopen: {
        empty: "Une heure d'ouverture du matin ne peut pas être vide.",
      },
      morningclose: {
        empty: 'Une heure de fermeture du matin ne peut pas être vide.',
      },
      afternoonopen: {
        empty: "Une heure d'ouverture de l'après midi ne peut pas être vide.",
      },
      afternoonclose: {
        empty: "Une heure de fermeture de l'après midi ne peut pas être vide.",
      },
      hours: {
        invalid: "Les horaires d'ouverture sont invalides.",
      },
    },
    site: {
      code: {
        empty: 'Le code du site de contrôle ne peut pas être vide.',
        length: 'Le code du site de contrôle doit contenir entre 1 et 10 caractères.',
        exists: 'Le code saisi existe déjà pour un autre site de contrôle.'
      },
      name: {
        empty: 'Le nom du site de contrôle ne peut pas être vide.',
        length: 'Le nom du site de contrôle doit contenir entre 1 et 50 caractères.'
      },
      french_description: {
        length: 'La description française du site de contrôle doit contenir au maximum 255 caractères.'
      },
      english_description: {
        length: 'La description anglaise du site de contrôle doit contenir au maximum 255 caractères.'
      },
      address: {
        empty: 'L\'adresse du site de contrôle ne peut pas être vide.',
      },
      phone_number: {
        length: 'Le numéro de téléphone du site de contrôle doit contenir au maximum 50 caractères.'
      },
      timezone: {
        empty: 'Le fuseau horaire du site de contrôle ne peut pas être vide.',
        length: 'Le fuseau horaire du site de contrôle doit contenir entre 1 et 10 caractères.',
        invalid: 'Le fuseau horaire saisi est invalide.'
      },
      cluster: {
        empty: 'Le cluster du site de contrôle ne peut pas être vide.',
        length: 'Le cluster du site de contrôle doit contenir entre 1 et 255 caractères.'
      },
      delete: {
        offices: 'Le site de contrôle ne peut pas être supprimé parce qu\'au moins un bureau est associé.'
      }
    },
    roaming_team: {
      name: {
        blank: 'Le nom de l\'équipe mobile ne peut pas être vide.',
        length: 'Le nom de l\'équipe mobile doit contenir entre 1 et 30 caractères.',
        exists: 'Le nom saisi est déjà utilisé pour une autre équipe mobile.'
      },
      planning: {
        empty: 'L\'équipe mobile doit avoir des horaires de disponibilité.',
      },
      availability_start_date: {
        empty: 'L\'équipe mobile doit avoir une date de début de disponibilité.',
      },
      availability_end_date: {
        empty: 'L\'équipe mobile doit avoir une date de fin de disponibilité.',
      },
      invalid_dates: 'Les dates de disponibilité sont invalides.',
      delete: {
        appointments: 'L\'équipe mobile ne peut pas être supprimée parce qu’au moins un rendez-vous est programmé.'
      }
    },
    roaming_team_day_planning: {
      availability_start_time: {
        empty: 'Une heure de début de disponibilité ne peut pas être vide.'
      },
      availability_end_time: {
        empty: 'Une heure de fin de disponibilité ne peut pas être vide.'
      },
      invalid_hours: 'Les horaires de disponibilité sont invalides.'
    },
    lineid: {
      requestId: {
        exists: "L'identifiant saisi existe pour une autre attribution de fréquence.",
        empty: "L'identifiant ne doit pas être vide.",
        length: "L'identifiant doit contenir 1 caractères au minimum",
      },
      stakeholderId: {
        empty: "L'identifiant du titulaire ne doit pas être vide.",
        deactivate: 'Ce titulaire est désactivé',
      },
      requestDate: {
        empty: 'La date de requête ne doit pas être vide.'
      },
      licencePeriod: {
        empty: 'La période de licence ne doit pas être vide.',
        length: 'La période de licence doit contenir maximum 125 caractères',
        invalid: 'La période de licence est inconnue.'
      },
      startDate: {
        empty: 'La date de début ne doit pas être vide.'
      },
      endDate: {
        empty: 'La date de fin ne doit pas être vide.'
      },
      spectrumService: {
        empty: 'Le type d\'équipement ne doit pas être vide.',
        length: 'Le type d\'équipement doit contenir maximum 125 caractères.'
      },
      spectrumServiceOther: {
        length: 'Autre type d\'équipement doit contenir maximum 256 caractères.'
      },
      mainVenue: {
        empty: 'La lieu d\'événement ne doit pas être vide.',
        length: 'Le lieu d\'événement doit contenir maximum 256 caractères.'
      },
      otherVenues: {
        length: 'Les autres sites doivent contenir maximum 256 caractères.'
      },
      specificLocation: {
        length: 'La location spécifique doit contenir maximum 256 caractères.'
      },
      usageType: {
        empty: 'La type d\'usage ne doit pas être vide.',
        length: 'Le type d\'usage doit contenir maximum 125 caractères.',
        invalid: 'Le type d\'usage est inconnu.'
      },
      duplex: {
        empty: 'Duplex ne doit pas être vide.'
      },
      tuningRangeFrom: {
        empty: 'La bande de fréquence minimale ne doit pas être vide.',
        invalid: 'La bande de fréquence minimale doit être comprise entre 1 et 999999.'
      },
      tuningRangeTo: {
        empty: 'La bande de fréquence maximale ne doit pas être vide.',
        invalid: 'La bande de fréquence maximale doit être comprise entre 1 et 999999.'
      },
      channelBandwidth: {
        empty: 'La largeur de bande ne doit pas être vide.',
        invalid: 'La largeur de bande doit être comprise entre 0 et 999999.'
      },
      tuningStep: {
        empty: 'Le pas de réglage ne doit pas être vide.',
        invalid: 'Le pas de réglage doit être compris entre 1 et 999999.'
      },
      transmissionPower: {
        empty: 'La puissance d\'émission ne doit pas être vide.',
        invalid: 'La puissance d\'émission doit être comprise entre 0 et 99999.'
      },
      numberEquipment: {
        empty: 'Le nombre d\'équipements similaires ne doit pas être vide.',
        invalid: 'Le nombre d\'équipements doit être compris entre 1 et 999999.'
      },
      manufacturer: {
        length: 'Le fabricant doit contenir maximum 125 caractères.'
      },
      equipmentReference: {
        length: 'La référence de l\'équipement doit contenir maximum 125 caractères.'
      },
      antennaReference: {
        length: 'La référence de l\'antenne doit contenir maximum 125 caractères.'
      },
      satelliteName: {
        length: 'Le nom du satellite doit contenir maximum 125 caractères.'
      },
      antennaHalfPowerAngle: {
        length: 'L\'azimut de l\'antenne doit contenir maximum 125 caractères.'
      },
      antennaHeightAboveGround: {
        empty: 'La hauteur de l\'antenne ne doit pas être vide.',
        invalid: 'La hauteur de l\'antenne doit être comprise entre 0 et 999999.'
      },
      antennaDiameter: {
        invalid: 'Le diamètre de l\'antenne doit être compris entre 0 et 999,99.'
      },
      standardTechnology: {
        length: 'La technologie standard doit contenir maximum 125 caractères.'
      },
      wirelessLanSsid: {
        length: 'Le SSID de la LAN doit contenir maximum 256 caractères.'
      },
      wirelessLanMacAddress: {
        length: 'L\'adresse MAC de la LAN doit contenir maximum 256 caractères.'
      },
      remarks: {
        length: 'Les remarques doivent contenir maximum 1024 caractères.'
      },
      duplexHigh: {
        empty: 'La fréquence attribuée ou canal (Simplex/Duplex haute) ne doit pas être vide.',
        length: 'La fréquence attribuée ou canal (Simplex/Duplex haute) doit contenir maximum 125 caractères.'
      },
      duplexLow: {
        empty: 'La fréquence attribuée (Duplex basse) ne doit pas être vide.',
        length: 'La fréquence attribuée (Duplex basse) doit contenir maximum 125 caractères.'
      },
      status: {
        empty: 'Le statut ne doit pas être vide.',
        length: 'Le statut doit contenir maximum 125 caractères.'
      },
      date: {
        invalid: 'La date de fin ne peut pas être avant la date de début.',
      },
      agent: {
        forbiddenfields:
          "Un agent n'est pas autorisé à modifier tous les champs.",
      },
      delete: {
        associated: 'Une attribution de fréquence est liée à un contrôle.',
      }
    },
    barcode: {
      exists: 'Le code-barre existe déjà.',
      notfound: 'Le code-barre est associé à aucun contrôle.',
      start : {
        empty : 'Début de la plage ne doit pas être vide'
      },
      end : {
        empty : 'Fin de la plage ne doit pas être vide'
      }
    },
    immediatetagging: {
      date: {
        empty: 'La date ne doit pas être vide.',
      },
      user: {
        empty: 'L\'utilisateur ne doit pas être vide.',
        invalidrole: 'L\'utilisateur doit être un contact.',
      },
      mainvenue: {
        empty: 'Le lieu d\'événement ne doit pas être vide.',
        invalid: 'Le lieu d\'événement est invalid.',
      }
    },
    venue: {
      code: {
        empty: 'Le code du lieu d\'événement ne peut pas être vide.',
        length: 'Le code du lieu d\'événement doit contenir au maximum 255 caractères.'
      },
      frenchWording: {
        empty: 'Le libellé français du lieu d\'événement ne peut pas être vide.',
        length: 'Le libellé français du lieu d\événement doit contenir au maximum 255 caractères.'
      },
      englishWording: {
        empty: 'Le libellé anglais du lieu d\'événement ne peut pas être vide.',
        length: 'Le libellé anglais du lieu d\'événement doit contenir au maximum 255 caractères.'
      },
      address: {
        empty: 'L\'adresse du lieu d\'événement ne peut pas être vide.',
      },
      timeZone: {
        empty: 'Le fuseau horaire du lieu d\'événement ne peut pas être vide.',
        length: 'Le fuseau horaire du lieu d\'événement entre 1 et 255 caractères.',
        invalid: 'Le fuseau horaire saisi est invalide.'
      },
      delete: {
        data: 'Le lieu d\'événement est relié à des données et ne peut être supprimé.'
      }
    },
    maxBarcode: 'La limite dans une plage est de 1000',
    contact: {
      firstname: {
        empty: 'Le prénom du contact ne peut pas être vide',
        length: 'Le prénom du contact doit contenir un maximum de 100 caractères',
      },
      lastname: {
        empty: 'Le nom du contact ne peut pas être vide',
        length: 'Le nom du contact doit contenir un maximum de 100 caractères',
      },
      profession: {
        empty: 'La fonction du contact ne peut pas être vide',
        length: 'La fonction du contact doit contenir un maximum de 100 caractères',
      },
      company: {
        length: 'La société du contact doit contenur un maximum de 255 caractères',
      },
      email:{
        regex: "L'email du contact doit respecter la regex de validation d'une adresse email de type Unicode ou Non-Latin",
      },
      phonenumber: {
        empty: 'Le numéro de téléphone du contact ne peut pas être vide',
        length: 'Le numéro de téléphone du contact doit contenir un maximum de 50 caractères',
      }
    },
    address: {
      name: {
        empty: "Le nom de l'adresse ne peut pas être vide",
      },
      postcode: {
        empty: "Le code postal de l'adresse ne peut pas être vide",
        length: 'Le code postal doit contenir maximum 10 caractères.'
      },
      city: {
        empty: "Le nom de la ville de  l'adresse ne peut pas être vide"
      },
      country: {
        empty: "Le nom du pays de l'adresse ne peut pas être vide"
      },
      longitude: {
        empty: "La longitude de l'adresse ne peut pas être vide"
      },
      latitude: {
        empty: "La latitude de l'adresse ne peut pas être vide"
      }
    },
    specialrequest:{
        id: {
          empty: "L'identifiant de la demande spécial ne peut pas être vide",
          invalid: "L'identifiant de la demande spécial ne peut pas être renseigné avec une valeur incorrecte"
        },
        contact: {
          empty: 'Les informations concernant le contact ne peut pas être vide',
        },
        specialrequestcontact: {
          empty: 'Les informations concernant le contact de la demande spécial ne peut pas être vide'
        },
        reasonrequest: {
          empty: 'La raison de la demande spéciale ne peut pas être vide',
          undefined: 'La raison de la demande spéciale doit correspondre à une valeur valide'
        },
        localizingmaterials: {
          empty: 'La localisation du matériel ne peut pas être vide',
          undefined: 'La localisation du matériel doit correspondre à une valeur valide'
        },
        detailsotherlocalizingmaterials: {
          empty: "Le détail de l'indication d'une autre localisation du matériel ne peut pas être vide",
        },
        vehiculetype: {
          empty: 'Le type de véhicule ne peut pas être vide',
          undefined: 'Le type de véhicule doit correspondre à une valeur valide'
        },
        detailsothervehiculetype: {
          empty: "Le détail de l'indication d'un autre véhicule ne peut pas être vide",
        },
        equipmentsspecialrequests: {
          empty: 'La liste des équipements devant être attribuées ne peut pas être vide',
        },
        startingavailabilitydatetime: {
          empty: 'La date de début de la disponinilité ne peut pas être vide',
        },
        endingavailabilitydatetime: {
          empty: 'La date de fin de la disponibilité ne peut pas être vide',
          endingbeforestarting: 'La date de fin de la dispobilité ne peut pas être avant la date de début de disponibilité'
        },
        wishedmeetingaddress: {
          empty: "L'adresse souhaité pour le rendez-vous ne peut pas être vide",
        },
        creationdate: {
          empty: 'La date de création de la demande ne peut pas être vide',
        },
        status: {
          empty: 'Le statut de la demande ne peut pas être vide',
          invalid: "Le statut n'est pas dans le bon état pour réaliser l'action",
        },
        answer: {
          empty: 'La réponse ne peut pas être vide',
          notempty: 'La réponse ne peut pas être renseigné tant que la demande est en cours',
          toolong: 'La réponse doit contenir un maximum de 1024 caractères'
        },
        request:{
          notfound: "La demande spéciale souhaitée n'existe pas"
        }
    }
  },
  entity: {
    user: {
      id: 'ID',
      name: 'Nom',
      user: 'Utilisateur',
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'Adresse email',
      stakeholderId: 'Titulaire',
      company: 'Société utilisatrice',
      phoneNumber: 'Numéro de téléphone',
      activated: 'Actif',
      role: 'Rôle',
      yubekey: 'Yubekey',
      approver: 'Approbateur de compte',
      approved: 'Approuvé',
      approvalDate: 'Date d\'approbation',
      rejectMessage: 'Message de refus',
      roles: {
        CONTACT_ROLE: 'Contact',
        AGENT_ROLE: 'Agent',
        ADMIN_ROLE: 'Administrateur',
        contact: 'Contact',
        agent: 'Agent',
        admin: 'Administrateur',
        approver: 'Approbateur de compte'
      },
      approvefilter: {
        toapprove: 'En attente',
        approved: 'Approuvé',
        notapproved: 'Non approuvé'
      }
    },
    appointment: {
      date: 'Date',
      day: 'Jour',
      start: 'Heure de début',
      end: 'Heure de fin',
      duration: 'Durée',
      appointmentTime: 'Créneau horaire',
      office: 'Bureau',
      roamingTeam: 'Équipe mobile',
      status: 'Statut',
      statuses: {
        pending: 'En attente',
        honored: 'Honoré',
        canceled: 'Annulé',
        no_show: 'Non présenté',
      },
    },
    office: {
      office: 'Bureau',
      name: 'Nom',
      site: 'Site',
      enabled: 'Activé',
      disabled: 'Désactivé',
      state: 'État',
      openDate: "Date d'ouverture",
      closeDate: 'Date de fermeture',
      openCloseDate: "Dates d'ouverture et fermeture",
      planning: "Horaires d'ouverture",
    },
    roamingTeam: {
      name: 'Nom',
      active: 'Active',
      inactive: 'Inactive',
      state: 'État',
      availabilityStartDate: 'Date de début de disponibilité',
      availabilityEndDate: 'Date de fin de disponibilité',
      planning: 'Horaires de disponibilité',
      availabilityDates: 'Dates de disponibilité'
    },
    planning: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      morning: 'Matin',
      afternoon: 'Après midi',
      from: 'De',
      to: 'à',
    },
    stakeholder: {
      name: 'Nom de la compagnie',
      stakeholderId: 'Identifiant',
    },
    lineId: {
      requestId: 'Identifiant de la requête',
      stakeholderId: 'Identifiant du titulaire',
      requestDate: 'Date de la requête',
      licencePeriod: 'Période de la licence',
      listLicencePeriods: 'Périodes des licences',
      startDate: 'Début d\'autorisation',
      endDate: 'Fin d\'autorisation',
      spectrumService: 'Type d\'équipement',
      spectrumServiceOther: 'Autre équipement',
      mainVenue: 'Lieu d\'événement',
      listMainVenues: 'Liste des lieux d\'événement',
      otherVenues: 'Autres sites',
      specificLocation: 'Localisation',
      usageType: "Type d'usage",
      duplex: 'Duplex',
      tuningRangeFrom: 'Bande de fréquence minimale (MHz)',
      tuningRangeTo: 'Bande de fréquence maximale (MHz)',
      channelBandwidth: 'Largeur de bande (kHz)',
      tuningStep: 'Pas de réglage (kHz)',
      transmissionPower: 'Puissance d\'émission (mW)',
      manufacturer: 'Fabricant',
      equipmentReference: 'Référence de l\'équipement',
      numberOfEquipment: 'Nombre d\'équipements similaires',
      antennaReference: 'Référence de l\'antenne',
      satelliteName: 'Nom du satellite',
      antennaHalfPowerAngle: 'Azimut (degrés)',
      antennaDiameter: 'Diamètre de l\'antenne (m)',
      antennaHeightAboveGround: 'Hauteur de l\'antenne au-dessus du sol (m)',
      standardTechnology: 'Standard / Technologie',
      wirelessLanSsid: 'SSID de la LAN',
      wirelessLanMacAddress: 'Adresse MAC de la LAN',
      remarks: 'Remarques',
      duplexHigh: 'Fréquence attribuée ou canal (Simplex/Duplex haute)',
      duplexLow: 'Fréquence attribuée (Duplex basse)',
      status: 'Statut',
      associated: 'Associée',
      notassociated: 'Non associée',
      usageTypes: {
        'Air to Ground': 'Air - Sol',
        'Ground to Air': 'Sol - Air',
        'Ground to Ground': 'Sol - Sol',
        'Air to Air': 'Air - Air'
      },
      licencePeriods: {
        'Olympic': 'Olympique',
        'Olympic Opening Ceremony': 'Cérémonie d\'ouverture Olympique',
        'Olympic Closing Ceremony': 'Cérémonie de fermeture Olympique',
        'Paralympic': 'Paralympique',
        'Paralympic Opening Ceremony': 'Cérémonie d\'ouverture Paralympique',
        'Paralympic Closing Ceremony': 'Cérémonie de fermeture Paralympique'
      },
      statusOptions: {
        approved: 'Accepté',
        refused: 'Refusé',
      },
      duplexOptions: {
        true: 'Oui',
        false: 'Non',
      },
    },
    site: {
      site: 'Site de contrôle',
      code: 'Code',
      name: 'Nom',
      french_description: 'Description française',
      english_description: 'Description anglaise',
      address: {
        field: 'Adresse',
        name: 'Nom',
        country: 'Pays',
        postcode: 'Code postal',
        city: 'Ville',
      },
      phone_number: 'Numéro de téléphone',
      timezone: 'Fuseau horaire',
      cluster: 'Cluster',
      enabled: 'Activé',
      disabled: 'Désactivé'
    },
    barcode: {
      list: 'Liste des codes-barres',
      code: 'Code',
      start: 'Début de la plage d\'étiquettes',
      deleted: 'Supprimé',
      content: 'Voulez vous vraiment supprimer ce code-barre ?',
      end: 'Nombre de code',
      creationDate : 'Date de création',
      from : 'De',
      fromLowercase : 'de',
      to : 'à',
      user : 'Agent'
    },
    control: {
      associated: 'Association',
      creation: 'Création',
      deletion: 'Suppression',
      disassociationDate:'Date de désassociation',
      associationDate: 'Date d\'association',
      disassociationDetails:'Détails de désassociation',
      associationUser: 'Agent (association)',
      disassociationUser: 'Agent (désassociation)',
      disassociation: 'Désassociation',
    },
    specialrequest: {
      specialrequest: 'Demande spéciale',
      message: 'Merci de saisir manuellement les différents types d’équipements à contrôler, leur nombre, l’adresse souhaitée pour le rendez-vous, ainsi que vos disponibilités.\nN’hésitez pas à indiquer toute autre information pouvant aider à la préparation et au bon déroulement du contrôle.',
      answer: 'Réponse',
      status: 'Statut',
      statusOptions: {
        PENDING: 'En attente',
        REJECTED: 'Refusée',
        ACCEPTED: 'Validée',
      },
      reasons: {
        localizingmaterials: 'Matériel entreposé dans un lieu fixe',
        materialsinvehicle: 'Matériel embarqué dans un véhicule'
      },
      materialLocalisations: {
        warehouse: 'Stocké en entrepôt ou local (hors site de l\'événement)',
        onsite: 'Présent sur le site de l\'événement',
        other: 'Autre localisation — préciser :'
      },
      vehicleTypes: {
        outsidebroadcastvan: 'Outside Broadcast Van',
        sngvehicle: 'Véhicule SNG',
        car: 'Automobile',
        motorbike: 'Moto',
        plane: 'Avion',
        helicopter: 'Hélicoptère',
        boat: 'Bateau',
        drone: 'Drone',
        other: 'Autre et préciser',
      },
      reasonRequest: 'Raison de la demande spéciale',
      localizingMaterials: 'Précisez où se trouve le matériel',
      detailsOtherLocalizingMaterials: 'Autre localisation du matériel',
      vehicleTypesLabel: 'Types de véhicules',
      detailsOtherVehiculeType: 'Autre type de véhicule',
      commentary: 'Commentaire',
      availabilityDatetime: 'Dates de disponibilités',
      startAvailabilityDatetime: 'Début',
      endAvailabilityDatetime: 'Fin',
      wishedMeetingAddress: 'Adresse du lieu de rendez-vous souhaité',
      specialRequestContact: {
        lastName: 'Nom',
        firstName: 'Prénom',
        profession: 'Fonction',
        company: 'Société',
        phoneNumber: 'Numéro de téléphone',
        email: 'Adresse électronique',
      }
    },
    equipmentType: {
      code: 'Code',
      frenchWording: 'Libellé français',
      englishWording: 'Libellé anglais',
      field : {
        type: 'Type',
        quantity: 'Quantité',
        placeholderType: 'Sélectionner',
        placeholderQuantity: 'Entrer une quantité'
      }
    },
    venue: {
      id: 'id',
      code: 'Code',
      frenchWording: 'Libellé français',
      englishWording: 'Libellé anglais',
      address: 'Adresse',
      timeZone: 'Fuseau horaire'
    }
  },
  nav: {
    home: 'Accueil',
    dummy: 'Dummy',
    user: 'Utilisateurs',
    logout: 'Déconnexion',
    login: 'Connexion',
    register: 'Créer un compte',
    site: 'Sites de contrôle',
    office: 'Bureaux',
    roamingTeam: 'Équipes mobiles',
    stakeholder: 'Titulaires',
    lineId: 'Fréquences attribuées',
    createAppointment: 'Prise de rendez-vous',
    immediateTagging: 'Étiquetage immédiat',
    createImmediateTagging: 'Créer un étiquetage immédiat',
    appointments: 'Étiquetage planifié',
    specialrequest: 'Demande spéciale',
    specialrequests: 'Demandes spéciales',
    barcodeControl: 'Recherche de demande',
    userDetail: "Détail de l'utilisateur",
    userTagHistory: 'Historique des étiquetages',
    officeDetail: 'Détail du bureau',
    lineIdDetail: "Détail de l' attribution de fréquence",
    appointmentDetail: 'Détail de rendez-vous',
    immediateTaggingSummary: 'Récapitulatif de l\'étiquetage immédiat',
    immediateTaggingDetail: 'Détail de l\'étiquetage immédiat',
    tag: 'Étiquettes',
    userProfile : 'Vous êtes connecté en tant que',
    equipmentType : 'Types d\'équipement',
    roamingTeamDetail: 'Détail de l\'équipe mobile',
    siteDetail: 'Détail du site de contrôle',
    venue: 'Lieux d\'événement',
    settings: 'Paramètres'
  },
  action: {
    crud: {
      create: 'Créer',
      import: 'Importer',
      export: 'Exporter',
      exportCsv: 'Export CSV',
      importCsv: 'Import CSV',
      read: 'Voir',
      update: 'Modifier',
      delete: 'Supprimer',
    },
    reset: 'Réinitialiser',
    extend: 'Étendre',
    collapse: 'Réduire',
    sendSummary: 'Envoyer le récapitulatif de la demande',
    search: 'Rechercher',
    add: 'Ajouter',
    scan: 'Scanner',
    associate: 'Associer',
    overview: 'Aperçu',
    yes: 'Oui',
    no: 'Non',
    back: 'Retour',
    confirm: 'Valider',
    reject: 'Rejeter',
    cancel: 'Annuler',
    details: 'Détails',
    at: 'à',
    by: 'par',
    visualize: 'Visualiser',
    filter: {
      all: 'Tous'
    }
  },
  legacynoticepage: legacynotice,
  gcupage: gcu,
  loginpage: {
    input: {
      email: 'Adresse mail',
      password: 'Mot de passe',
      login: 'Me connecter',
      resetpassword: "J'ai oublié mon mot de passe",
    },
    captcha: {
      title:
        'Test de sécurité : veuillez répondre à la question suivante pour poursuivre',
      waiting:
        'Veuillez patienter pendant le chargement du test de sécurité...',
      placeholder: 'Saisir le captcha',
    },
  },
  resetpasswordpage: {
    title: 'Réinitialiser mon mot de passe',
    input: {
      email: 'Adresse mail',
      reset: 'Réinitialiser',
      information:
        'Un email contenant la procédure de réinitialisation de mot de passe vous a été envoyé si nous avons un compte correspondant à votre adresse email.',
    },
  },
  changepasswordpage: {
    title: 'Changer mon mot de passe',
    input: {
      password: 'Mot de passe',
      passwordConfirmation: 'Confirmation du mot de passe',
      change: 'Changer le mot de passe',
    },
    expired: {
      message:
        "Ce lien a expiré. Cliquez ci-dessous pour retourner sur la page d'accueil :",
      home: "Retourner à l'accueil",
    },
    success: 'Le mot de passe a bien été modifié.',
  },
  registerpage: {
    fieldset: {
      stakeholder: 'Identifiant du Titulaire',
      contact: 'Contact',
    },
    input: {
      stakeholder: 'Identifiant',
      lastname: 'Nom',
      firstname: 'Prénom',
      company: 'Société utilisatrice',
      email: 'Adresse mail',
      emailConfirmation: "Confirmation de l'adresse email",
      phoneNumber: 'Numéro de téléphone',
      password: 'Mot de passe',
      register: 'Créer mon compte',
      confirm_password: 'Confirmation du mot de passe',
    },
    messages: {
      success: "Compte créé avec succès. Un email d'activation vous a été envoyé par mail.",
      approval: "Compté créé avec succès. Il est actuellement en attente d'approbation"
    },
    appointment: 'Afficher les RDVs',
    captcha: {
      title:
        'Veuillez répondre  à la question suivante pour poursuivre la création de votre compte !',
    },
  },
  userdetailpage: {
    fieldset: {
      stakeholder: 'Titulaire',
      contact: 'Contact',
      account: 'Compte',
    },
    role: 'Rôle',
    account: {
      state: 'État',
      activate: 'Activé',
      desactivate: 'Désactivé',
    },
    roles: {
      contact: 'Contact',
      agent: 'Agent',
      admin: 'Administrateur',
    },
    approved: 'Compte approuvé',
    showappointments: 'Voir les rendez-vous',
  },
  taghistorypage: {
    title: 'Historique des étiquetages',
  },
  user: {
    validation: {
      email: {
        exists: 'Un compte existe déjà avec cette adresse email',
      },
    },
  },
  activationPage: {
    success: 'Votre compte est maintenant activé, merci de vous authentifier.',
    failed: "Impossible d'activer l'utilisateur, veuillez réessayer plus tard.",
    backtohome: "Retour à la page d'accueil.",
  },
  userpage: {
    nouser: 'Aucun utilisateur à afficher.',
    locked: 'Bloqué',
    title: {
      detail: "Voir le profil de l'utilisateur",
      delete: "Supprimer l'utilisateur",
      reject: "Refuser l'approbation",
      approve: "Approuver l'utilisateur"
    },
    dialog: {
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez vous vraiment supprimer cet utilisateur ?',
      },
      activate: {
        header: "Confirmation d'activation",
        content: 'Voulez vous vraiment activer cet utilisateur ?',
      },
      deactivate: {
        header: 'Confirmation de désactivation',
        content: 'Voulez vous vraiment désactiver cet utilisateur ?',
      },
      reject: {
        header: 'Confirmation de refus',
        content: 'Voulez vous vraiment refuser l\'approbation ?',
        message: 'Message de refus :'
      },
      approval: {
        header: 'Confirmation d\'approbation',
        content: 'Voulez vous vraiment approuver cet utilisateur ?'
      },
      abortButton: 'Annuler',
      rejectButton: 'Refuser',
      confirmButton: 'Valider',
    },
    toast: {
      activate: {
        success: 'Utilisateur activé',
        error: "Problème dans l'activation",
      },
      deactivate: {
        success: 'Utilisateur désactivé',
        error: 'Problème dans la désactivation',
      },
      delete: {
        success: 'Utilisateur supprimé',
        error: 'Problème dans la suppression',
      },
      approval: {
        success: 'Utilisateur approuvé',
        reject: 'Approbation refusée'
      }
    },
    createUser: 'Créer un utilisateur',
    accountToApprove: 'Comptes à approuver',
    createSuccess: 'Utilisateur créé avec succès.',
    updateUser: 'Modifier un utilisateur',
    updateSuccess: 'Utilisateur modifié avec succès.',
    form: {
      role: {
        placeholder: 'Sélectionnez un rôle',
      },
      stakeholdersApprover: 'Titulaires approuvables (laisser vide pour ne pas restreindre)'
    },
  },
  appointmentPage: {
    noOffice: 'Aucun bureau disponible',
    noRoamingTeam: 'Aucune équipe mobile disponible',
    control: {
      estimatedDuration: 'Durée estimée du contrôle :',
      effectiveDuration: 'Durée effective du contrôle :',
    },
    appointments: {
      sectionTitle: 'Sélection des créneaux de rendez-vous',
      selectInstruction:
        'Veuillez sélectionner un ou des créneaux de rendez-vous parmis les bureaux suivants :',
      duration: 'durée',
      selectedAppointments: 'Créneaux sélectionnés :',
      noSelectedAppointment:
        'Aucun créneau sélectionné. Utilisez les calendriers ci-dessus pour sélectionner des créneaux.',
      removeAppointment: 'Supprimer ce créneau',
      validateAppointments: 'Valider ces créneaux',
      remainingTime: 'Durée restante à planifier :',
      editDialogHeader: 'Edition du créneau de rendez-vous',
      searchByDate: 'Rechercher par date :',
      noOffice: 'Aucun bureau disponible',
    },
    equipment: {
      equipmentNumberInstruction:
        "Veuillez saisir le nombre d'équipements à contrôler :",
      equipmentType: "Type d'équipement :",
      equipmentNumber: 'Nombre d\'équipements ',
      equipments: 'équipement(s)',
      defaultEquipment: 'Je ne sais pas',
    },
    toast: {
      validate: 'Votre rendez-vous a bien été enregistré !',
      deleted: 'Votre réservation a bien été annulée',
    },
  },
  stakeholderpage: {
    create: 'Créer un titulaire',
    update: 'Modifier un titulaire',
    validation: 'Ajouter le titulaire',
    locked: 'Bloqué',
    messages: {
      createSuccess: 'Le titulaire a bien été ajouté !',
      updateSuccess: 'Le titulaire a bien été modifié !',
    },
    dialog: {
      activate: {
        header: "Confirmation d'activation",
        content: 'Voulez vous vraiment activer ce titulaire ?',
      },
      deactivate: {
        header: 'Confirmation de désactivation',
        content: 'Voulez vous vraiment désactiver ce titulaire ?',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider',
    },
    toast: {
      activate: {
        success: 'Titulaire activé',
        error: "Problème dans l'activation",
      },
      deactivate: {
        success: 'Titulaire désactivé',
        error: 'Problème dans la désactivation',
      },
    },
    tooltip: {
      delete: 'Supprimer le titulaire',
    },
  },
  lineidpage: {
    create: 'Créer une attribution de fréquence',
    createSuccess: 'Attribution de fréquence créée avec succès.',
    update: 'Modifier une attribution de fréquence',
    import: 'Import PMSE Audio',
    updateSuccess: 'Attribution de fréquence modifiée avec succès.',
    delete: 'Supprimer la sélection',
    extractactivity: 'Indicateurs d\'activité',
    advancedFilters: 'Filtres avancés',
    tagmanagement: 'Gestion des étiquettes',
    associationsHistory: 'Historique des associations',
    fieldset: {
      information: 'Informations',
      location: 'Localisation',
      frequency: 'Spécifications de la fréquence',
      equipment: 'Spécifications de l\'équipement',
      antenna: 'Spécifications de l\'antenne',
      wifi: 'Spécifications Wifi',
      tnt: 'Test & Tagging'
    },
    dropdown: {
      status: 'Sélectionnez un statut',
      location: 'Sélectionner un lieu',
      licencePeriod: 'Sélectionner une période',
      usageTypes: 'Sélectionner un type d\'usage'
    },
    dialog: {
      import: {
        header: 'Importation d\'attributions de fréquence',
        uploadlabel: 'Fichier à importer (format csv avec entête, colonnes séparées par des ";").',
        error: 'Une erreur est survenue lors de l\'import, veuillez réessayer plus tard.',
        invalid: 'Le fichier fourni est invalide, les détails vous ont été envoyé par mail.',
        success: 'Les attributions de fréquence ont été importé avec succès.',
      },
      delete: {
        header: 'Confirmation de suppression',
        content:
          'Voulez vous vraiment supprimer cette attribution de fréquence ?',
      },
      deletemultiple: {
        header: 'Confirmation de suppression',
        content:
          'Voulez vous vraiment supprimer ces attributions de fréquences ?',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider',
    },
    tooltip: {
      detail: 'Voir la demande d\'attribution de fréquence',
      delete: "Supprimer l'attribution de fréquence"
    },
    toast: {
      delete: {
        success: 'Attribution de fréquence supprimée',
        error: 'Problème dans la suppression',
      },
      deletemultiple: {
        success: 'Attributions de fréquence supprimées',
        error: 'Problème dans la suppression',
      },
    },
  },
  officepage: {
    title: {
      delete: 'Supprimer le bureau',
      detail: 'Afficher le bureau',
    },
    createOffice: 'Créer un bureau',
    updateOffice: 'Modifier un bureau',
    dialog: {
      enable: {
        header: "Confirmation d'activation",
        content: 'Voulez vous vraiment activer ce bureau ?',
      },
      disable: {
        header: 'Confirmation de désactivation',
        content: 'Voulez vous vraiment désactiver ce bureau ?',
      },
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez vous vraiment supprimer ce bureau ?',
      },
      appointment: {
        header: 'Action invalide',
        content:
          'Un bureau ne peut pas être supprimé si il a des rendez-vous programmés.',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider',
    },
    toast: {
      enable: 'Bureau activé avec succès',
      disable: 'Bureau désactivé avec succès',
      delete: 'Bureau supprimé avec succès',
      updateSuccess: 'Bureau mis a jour avec succès',
      createSuccess: 'Bureau créé avec succès',
    },
  },
  officedetailpage: {
    fieldset: {
      site: 'Site',
      office: 'Bureau',
    },
    delete: 'Bureau supprimé avec succès',
  },
  sitesection: {
    title: "Sélection d'un site de contrôle",
    subtitle: 'Veuillez sélectionner un site de contrôle parmi les sites présentés ci-dessous.',
    quick_select: 'Sélection rapide',
    site: {
      title: 'Site de contrôle sélectionné : ',
      button: 'Prendre rendez-vous',
    },
    dropdown: 'Sélectionner un site de contrôle',
  },
  appointmentrecap: {
    title: 'RÉCAPITULATIF DE LA PRISE DE RENDEZ-VOUS',
    subtitle:
      "Veuillez vérifier les informations relatives à votre prise de rendez-vous et certifier l'exactitude des informations.",
    fieldset: {
      stakeholder: 'Titulaire',
      equipment: 'Équipements',
      site: 'Site de contrôle',
      appointment: 'Rendez-vous',
    },
    quantity: 'Quantité',
    conditions: "J'accepte les conditions générales.",
    validate: 'Valider ma prise de rendez-vous',
    dialog: {
      conditions: {
        header: "Conditions générales d'utilisation",
        content: '',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider',
    },
  },
  appointmentspage: {
    title: 'Étiquetage planifié',
    searchbarcode: 'Veuillez saisir ou scanner un code-barre',
    noappointmentfound: "Aucun rendez-vous n'a été trouvé",
  },
  userappointmentspage: {
    title: 'Rendez-vous',
    tab: {
      upcoming: 'Rendez-vous à venir',
      all: 'Tous les rendez-vous',
      immediatetagging: 'Étiquetage immédiat',
    },
    createappointment: 'Créer un rendez-vous'
  },
  appointmentdetailspage: {
    barcodes: 'codes-barres associés',
    equipmentNumber: 'Nombre d\'équipement à étiqueter :',
    equipmentTaggedNumber: 'Nombre d\'équipements étiquetés :',
    dialog: {
      addbarcode: {
        title: 'Scan des codes-barres',
      },
    },
    toast: {
      summarySuccess: 'Le récapitulatif a été envoyé avec succés',
    },
  },
  specialrequestcreatePage: {
    title: 'Demande spéciale',
    toast: {
      success: 'Votre demande a bien été prise en compte',
    },
    generalinformations: 'Informations principales',
    sitecontact: 'Contact sur lieu de rendez-vous'
  },
  specialrequestupdatePage: {
    title: 'Validation de la demande spéciale',
    details: 'Détails de la demande',
    contactOnSite: 'Contact sur lieu de rendez-vous',
    alreadyAnswered: 'Cette demande a déjà été traitée',
    toast: {
      success: 'Votre réponse bien été prise en compte',
    }
  },
  specialrequest: {
    id: {
      notfound: "La demande spécial n'a pas été trouvé"
    },
    txt_info:
      'Le temps de contrôle estimé est supérieur à 3 heures. Nous vous invitons à réaliser votre demande de rendez-vous par écrit. Vous serez recontacté dans les meilleurs délais .'
  },
  specialRequestPage: {
    startingAvailabilityDatetime: 'Date de début disponibilité',
    endingAvailabilityDatetime: 'Date de fin disponibilité',
    city: 'Ville',
    postcode: 'Code postal'
  },
  equipmentTypePage: {
    createEquipmentType: 'Créer un type d\'équipement',
    code: 'Code',
    frenchWording: 'Libellé français',
    englishWording: 'Libellé anglais',
    createSuccess: 'Type d\'équipement créé avec succès.',
    updateEquipmentType: 'Modifier un type d\'équipement',
    updateSuccess: 'Type d\'équipement modifié avec succès.',
    toast: {
      delete: {
        success: 'Type d\'équipement supprimé',
        error: 'Problème dans la suppression',
      }
    },
    dialog: {
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez vous vraiment supprimer ce type d\'équipement',
        abortButton: 'Annuler',
        confirmButton: 'Valider',
      }
    }
  },
  venuePage: {
    venue: 'Lieux d\'événement',
    code: 'Code',
    address: 'Adresse',
    timeZone: 'Fuseau horaire',
    active: 'Actif',
    createVenue: 'Créer un lieu d\'événement',
    updateVenue: 'Modifier un lieu d\'événement',
    createSuccess: 'Lieu d\'événement créé',
    updateSuccess: 'Lieu d\'événement modifié',
    toast: {
      delete: {
        success: 'Lieu d\'événement supprimé',
        error: 'Problème dans la suppression',
      },
      activate: {
        success: 'Lieu d\'événement activé',
        error: 'Problème dans l\'activation',
      },
      deactivate: {
        success: 'Lieu d\'événement désactivé',
        error: 'Problème dans la désactivation',
      }
    },
    dialog: {
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez vous vraiment supprimer ce lieu d\'événement',
        abortButton: 'Annuler',
        confirmButton: 'Valider',
      },
      activate: {
        header: 'Confirmation d\'activation',
        content: 'Voulez vous vraiment activer ce lieu d\'événement',
        abortButton: 'Annuler',
        confirmButton: 'Valider',
      },
      deactivate: {
        header: 'Confirmation de désactivation',
        content: 'Voulez vous vraiment désactiver ce lieu d\'événement',
        abortButton: 'Annuler',
        confirmButton: 'Valider',
      }
    }
  },
  venueDetailPage: {
    title: 'Détail du lieu d\'événement',
    venue: 'Lieu d\'évémement'
  },
  settingsPage: {
    title: 'Paramètres de l\'application',
    eventData: 'Données de l\'événement',
    exportEventData: 'Exporter les données de l\'événement',
    deleteEventData: 'Supprimer les données de l\'événement',
    toast: {
      delete: {
        in_progress: 'Suppression des données en cours',
        success: 'Données de l\'événement supprimées avec succès'
      }
    },
    dialog: {
      delete: {
        content: 'Êtes-vous sûr de vouloir supprimer les données de l\'événement ? Cette action est irréversible.',
        confirmButton: 'Confirmer',
        abortButton: 'Annuler'
      }
    }
  },
  dialog: {
    appointmentdetails: {
      title: 'Aperçu du rendez-vous',
      details: 'Détails',
    },
    deleteappointment: {
      title: 'Annulation de rendez-vous',
      content: "Veuillez confirmer l'annulation du rendez-vous suivant : ",
      toast: {
        delete: 'Rendez-vous annulé avec succès',
      },
    },
    barcodeform: {
      title: 'Création d\'une plage d\'étiquettes',
      toast: {
        success: 'Plage créée avec succès',
        error: 'Problème dans la création'
      }
    },
    detailbarcode: {
      title: 'Détail de la plage d\'étiquettes',
    },
    editbarcode: {
      title: 'Modifier le détail de la plage d\'étiquettes',
      subtitle: 'Veuillez sélectionner les fréquences attribuées associées à la plage d\'étiquettes.',
      message: {
        title : 'Confirmation',
        content1: 'Le/les codes-barres',
        content2: 'ne seront plus associés à aucunes fréquences attribuées',
      },
      togglecontrolsuccess: 'Le/les code-barres ont été modifié avec succès',
    },
    deletebarcode: {
      title: 'Suppression de la plage d\'étiquettes',
      content: 'La suppression d\'une plage d\'étiquettes engendre la supression de toutes les associations avec des attributions de fréquence.'
    }
  },
  roamingteampage: {
    create: 'Créer une équipe mobile',
    update: 'Modifier une équipe mobile',
    title: {
      detail: 'Afficher l\'équipe mobile',
      delete: 'Supprimer l\'équipe mobile'
    },
    dialog: {
      enable: {
        header: "Confirmation d'activation",
        content: 'Voulez-vous vraiment activer cette équipe mobile ?'
      },
      disable: {
        header: 'Confirmation de désactivation',
        content: 'Voulez-vous vraiment désactiver cette équipe mobile ?'
      },
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez-vous vraiment supprimer cette équipe mobile ?',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider'
    },
    toast: {
      createSuccess: 'Équipe mobile créée avec succès',
      updateSuccess: 'Équipe mobile mise à jour avec succès',
      enableSuccess: 'Équipe mobile activée avec succès',
      disableSuccess: 'Équipe mobile désactivée avec succès',
      deleteSuccess: 'Équipe mobile supprimée avec succès'
    }
  },
  roamingteampagedetailpage: {
    fieldset: {
      roamingteam: 'Équipe mobile',
    }
  },
  sitepage: {
    create: 'Créer un site de contrôle',
    update: 'Modifier un site de contrôle',
    title: {
      detail: 'Afficher le site de contrôle',
      delete: 'Supprimer le site de contrôle'
    },
    dialog: {
      enable: {
        header: "Confirmation d'activation",
        content: 'Voulez-vous vraiment activer ce site de contrôle ainsi que les bureaux associés ?'
      },
      disable: {
        header: 'Confirmation de désactivation',
        content: 'Voulez-vous vraiment désactiver ce site de contrôle ainsi que les bureaux associés ?'
      },
      delete: {
        header: 'Confirmation de suppression',
        content: 'Voulez-vous vraiment supprimer ce site de contrôle ?',
      },
      abortButton: 'Annuler',
      confirmButton: 'Valider'
    },
    toast: {
      createSuccess: 'Site de contrôle créé avec succès',
      updateSuccess: 'Site de contrôle mis à jour avec succès',
      enableSuccess: 'Site de contrôle activé avec succès',
      disableSuccess: 'Site de contrôle désactivé avec succès',
      deleteSuccess: 'Site de contrôle supprimé avec succès'
    }
  },
  sitedetailpage: {
    fieldset: {
      site: 'Site de contrôle',
      address: 'Adresse'
    }
  },
  stakeholderselection: {
    title: 'Sélectionner ou créer un titulaire',
    stakeholder: 'Titulaire',
    select: 'Sélectionner',
    or: 'OU',
    new: 'Nouveau titulaire'
  },
  userselection: {
    title: 'Sélectionner ou créer un contact',
    user: 'Contact',
    select: 'Sélectionner',
    or: 'OU',
    new: 'Nouveau contact',
    not_activated: 'L\'email est lié à un compte contact non activé.',
    resend_activation_link: 'Renvoyer le lien d\'activation par email',
    resend_success: 'Email d\'activation renvoyé avec succès'
  },
  venueselection: {
    title: 'Sélectionner un lieu d\'événement',
    select: 'Sélectionner'
  },
  footer: {
    home: 'ANFR',
    mentionLegal: 'Mentions Légales',
    cgu: 'CGU',
  },
  maintenancepage: {
    unavailable: 'Service indisponible',
    subtitle: 'L\'application est en cours de maintenance.'
  },
  error: {
    global: 'Une erreur est survenue',
    technical: 'Une erreur technique est survenue',
  },
  warning: {
    sessionended: 'Votre session a expiré, veuillez vous reconnecter.',
  },
  primevue: {
    startsWith: 'Commence par',
    contains: 'Contient',
    notContains: 'Ne contient pas',
    endsWith: 'Fini par',
    equals: 'Egual',
    notEquals: 'Pas egual',
    noFilter: 'Pas de filtre',
    lt: 'Inferieur à',
    lte: 'Inferieur ou egual à',
    gt: 'Superieur à',
    gte: 'Superieur ou égual à',
    dateIs: 'La date est',
    dateIsNot: "La date n'est pas",
    dateBefore: 'La date est antérieur',
    dateAfter: 'La date est posterieur',
    clear: 'Vider',
    apply: 'Appliquer',
    matchAll: 'Correspondance total',
    matchAny: 'Correspondance partielle',
    addRule: 'Ajouter une règle',
    removeRule: 'Supprimer une règle',
    accept: 'Oui',
    reject: 'Non',
    choose: 'Choix',
    upload: 'Envoyer',
    cancel: 'Annuler',
    dayNames: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    monthNames: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    monthNamesShort: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Juin',
      'Juil',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: "Aujourd'hui",
    weekHeader: 'Sem',
    firstDayOfWeek: 1,
    dateFormat: 'dd-mm-yy',
    weak: 'Semaine',
    medium: 'Medium',
    strong: 'Gras',
    passwordPrompt: 'Veuillez saisir un mot de passe',
    emptyFilterMessage: 'Aucun résultat',
    emptyMessage: 'Aucun résultat',
    aria: {
      trueLabel: 'Oui',
      falseLabel: 'Non',
      nullLabel: '',
    }
  }
};
